export default __webpack_public_path__ + "static/gw2-icon-into-tyria-72d1f2f63bab9dd2591719d9fa75c077.png";